import $ from "jquery";
class StickyNavigation {
	
	constructor() {

		$(window).scroll(() => {

			this.checkTabContainerPosition();

		});		
		
	}


	checkTabContainerPosition() {
		// let navIndex = 1
		
		// // console.log($(window).scrollTop())
		// if($(window).scrollTop() <window.innerHeight -55){
		// 	// console.log("首页")
		// 	navIndex = 1
		// }else if($(window).scrollTop() < 2400){
		// 	// console.log("产品介绍")
		// 	navIndex = 2
		// }else if ( $(window).scrollTop() < 3800) {
		// 	// console.log("新闻中心")
		// 	navIndex = 3
		// }else{
		// 	// console.log("关于我们")
		// 	navIndex = 4
		// }

		const windowHeight = window.innerHeight;
		const scrollPosition = $(window).scrollTop();
		
		// 根据滚动位置和窗口高度来计算模块的位置
		const module1Position = windowHeight - 55; // 模块1的位置
		const module2Position = module1Position + 1000; // 模块2的位置
		const module3Position = module2Position + 1000; // 模块3的位置

		let navIndex;

		if (scrollPosition < module1Position) {
		navIndex = 1; // 模块1
		} else if (scrollPosition < module2Position) {
		navIndex = 2; // 模块2
		} else if (scrollPosition < module3Position) {
		navIndex = 3; // 模块3
		} else {
		navIndex = 4; // 模块4
		}

		if ($(window).scrollTop() > window.innerHeight - 55) {
				//吸顶
			$('.nav').addClass('active--top');
			$('.nav').removeClass('active--bottom');
			sessionStorage.setItem('navState', 'fixed')

		}else{
			//取消吸顶
			$('.nav').removeClass('active--top');
			$('.nav').addClass('active--bottom');	
			sessionStorage.setItem('navState', 'normal')
		}

		
		this.adjustLinePosition(navIndex);


	}

	// 调整#line的位置
	adjustLinePosition(navIndex) {
		// const navIndex = 1; // 你的计算逻辑
	
		// 根据navIndex获取目标链接
		const targetLink = document.links[navIndex];
	
		if (!targetLink) {
		  return;
		}
	
		const asd = document.querySelector('.logo-nav');
		const containerOffset = targetLink.parentElement.offsetLeft;
		// const navLeft = document.querySelector('.nav-link')
		// navLeft.offsetWidth
		// debugger
		const activeOffset = targetLink.offsetLeft - containerOffset;
		
		
		$('#line').css('width', targetLink.offsetWidth);
		$('#line').css('left', activeOffset + asd.offsetWidth );
	  }
	
	
}

new StickyNavigation();